'use strict';

require('./supplier.env'); //imports supplierId
const supplierArray = require('../.suppliers.js');
const chalk = require('chalk');

let supplierObj = undefined;

// find supplier id in supplier array
for (var i = supplierArray.length - 1; i >= 0; i--) {
    if (supplierArray[i].id == supplierId) {
        supplierObj = supplierArray[i];
    }
}

// default if no supplier

if (supplierObj === undefined) {
    supplierObj = supplierArray[0];
}

console.log(chalk.green('---'));
console.log(chalk.green('Supplier: ' + supplierObj.name));
console.log(chalk.green('---'));

module.exports = {
    NODE_ENV: '"production"',
    API: '"' + 'api/v1/' + supplierObj.id + '"',
    SUPPLIER: supplierObj,
};


//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = rBKV
// module chunks = 1